import { Injectable } from '@angular/core';
import { user as userData } from 'app/mock-api/common/user/data';

@Injectable({providedIn: 'root'})
export class UserMockApi
{
    private _user: any = userData;

    constructor()
    {
      
    }


}
